export const primaryColor = {
    color: "#4E99DB",
}

export const secondaryColor = {
    color: "#EBF9FF"
}